import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxTypeOneComponent } from './checkbox-type-one/checkbox-type-one.component';
import { CheckboxTypeTwoComponent } from './checkbox-type-two/checkbox-type-two.component';
import { CheckboxTypeThreeComponent } from './checkbox-type-three/checkbox-type-three.component';
import { QuestionWithOptionsComponent } from './question-with-options/question-with-options.component';
import { CardTypeOneComponent } from './card-type-one/card-type-one.component';
import { ButtonsComponent } from './buttons/buttons.component';
import { InputWithButtonComponent } from './input-with-button/input-with-button.component';
import { CardTypeTwoComponent } from './card-type-two/card-type-two.component';
import { GaugeComponent } from './gauge/gauge.component';
import { InputTextFieldComponent } from './input-text-field/input-text-field.component';
import { CardTypeFiveComponent } from './card-type-five/card-type-five.component';
import { InputFieldWithLabelAboveComponent } from './input-field-with-label-above/input-field-with-label-above.component';
import { CardTypeFourComponent } from './card-type-four/card-type-four.component';
import { OtpFieldComponent } from './otp-field/otp-field.component';
import { VideoComponent } from './video/video.component';
import { CheckboxWithTextComponent } from './checkbox-with-text/checkbox-with-text.component';
import { DomainRowsComponent } from './domain-rows/domain-rows.component';
import { DropdownSelectComponent } from './dropdown-select/dropdown-select.component';
import { OtpHeaderFieldComponent } from './otp-header-field/otp-header-field.component';
import { CheckboxTypeSixComponent } from './checkbox-type-six/checkbox-type-six.component';
import { ModalButtonComponent } from './modal-button/modal-button.component';
import { TableComponent } from './table/table.component';
import { ReadyDashboardComponent } from './ready-dashboard/ready-dashboard.component';
import { PlaceholderWithTextComponent } from './placeholder-with-text/placeholder-with-text.component';
import { CheckboxTypeFourComponent } from './checkbox-type-four/checkbox-type-four.component';
import { CheckboxTypeFiveComponent } from './checkbox-type-five/checkbox-type-five.component';
import { LabelTypeOneComponent } from './label-type-one/label-type-one.component';
import { ViewCardComponent } from './view-card/view-card.component';
import { DataViewWithLoaderComponent } from './data-view-with-loader/data-view-with-loader.component';
import { DomainWithTagsComponent } from './domain-with-tags/domain-with-tags.component';
import { InputSearchFieldsComponent } from './input-search-fields/input-search-fields.component';
import { ConsultCardComponent } from './consult-card/consult-card.component';
import { ResendOtpComponent } from './resend-otp/resend-otp.component';
import { PhoneNumberComponent } from './phone-number/phone-number.component';
import { IntegrationComponent } from './integration/integration.component';
import { ImageWithTextComponent } from './image-with-text/image-with-text.component';
import { CustomButtonComponent } from './custom-button/custom-button.component';
import { IntegrationCardsComponent } from './integration-cards/integration-cards.component';
import { IntegrationCardsProComponent } from './integration-cards-pro/integration-cards-pro.component';
import { IntegrationListComponent } from './integration-list/integration-list.component';
import { AutoFocusDirective } from '../../helpers/auto-focus.directive';
import { SummaryComponent } from './summary/summary.component';
import { SummaryCardsComponent } from './summary-cards/summary-cards.component';
import { SummaryViewComponent } from './summary-view/summary-view.component';
import { ConfigWithButtonComponent } from './config-with-button/config-with-button.component';
import { ConfigurationCardsComponent } from './configuration-cards/configuration-cards.component';
import { CheckboxTypeSevenComponent } from './checkbox-type-seven/checkbox-type-seven.component';
import { CheckboxTypeEightComponent } from './checkbox-type-eight/checkbox-type-eight.component';
import { LoginCardsComponent } from './login-cards/login-cards.component';
import { GroupedDropdownComponent } from './grouped-dropdown/grouped-dropdown.component';
import { FilterDropdownComponent } from './filter-dropdown/filter-dropdown.component';
import { FileUploadsComponent } from './file-uploads/file-uploads.component';
import { CheckboxTextComponent } from './checkbox-text/checkbox-text.component';
import { UserInviteComponent } from './user-invite/user-invite.component';
import { FrameworkDetailsComponent } from './framework-details/framework-details.component';
import { DropdownWithSearchComponent } from './dropdown-with-search/dropdown-with-search.component';
import { RoleDeleteImpactComponent } from './role-delete-impact/role-delete-impact.component';

@NgModule({
  declarations: [],
  imports: [
    AutoFocusDirective,
    CommonModule,
    CheckboxTypeOneComponent,
    CheckboxTypeTwoComponent,
    CheckboxTypeThreeComponent,
    PlaceholderWithTextComponent,
    QuestionWithOptionsComponent,
    CardTypeOneComponent,
    ButtonsComponent,
    InputWithButtonComponent,
    CardTypeTwoComponent,
    GaugeComponent,
    InputTextFieldComponent,
    CardTypeFourComponent,
    CardTypeFiveComponent,
    OtpFieldComponent,
    VideoComponent,
    InputFieldWithLabelAboveComponent,
    CheckboxWithTextComponent,
    CheckboxTypeFourComponent,
    CheckboxTypeFiveComponent,
    LabelTypeOneComponent,
    DomainRowsComponent,
    DropdownSelectComponent,
    OtpHeaderFieldComponent,
    ViewCardComponent,
    DataViewWithLoaderComponent,
    CheckboxTypeSixComponent,
    ModalButtonComponent,
    TableComponent,
    ReadyDashboardComponent,
    DomainWithTagsComponent,
    InputSearchFieldsComponent,
    ConsultCardComponent,
    ResendOtpComponent,
    PhoneNumberComponent,
    IntegrationComponent,
    ImageWithTextComponent,
    CustomButtonComponent,
    IntegrationCardsComponent,
    IntegrationCardsProComponent,
    IntegrationListComponent,
    SummaryComponent,
    SummaryCardsComponent,
    SummaryViewComponent,
    ConfigWithButtonComponent,
    ConfigurationCardsComponent,
    CheckboxTypeSevenComponent,
    CheckboxTypeEightComponent,
    LoginCardsComponent,
    GroupedDropdownComponent,
    FilterDropdownComponent,
    FileUploadsComponent,
    CheckboxTextComponent,
    UserInviteComponent,
    FrameworkDetailsComponent,
    DropdownWithSearchComponent,
    RoleDeleteImpactComponent,
  ],
  exports: [
    AutoFocusDirective,
    CheckboxTypeOneComponent,
    CheckboxTypeTwoComponent,
    CheckboxTypeThreeComponent,
    PlaceholderWithTextComponent,
    QuestionWithOptionsComponent,
    CardTypeOneComponent,
    ButtonsComponent,
    InputWithButtonComponent,
    CardTypeTwoComponent,
    GaugeComponent,
    InputTextFieldComponent,
    CardTypeFourComponent,
    CardTypeFiveComponent,
    OtpFieldComponent,
    VideoComponent,
    InputFieldWithLabelAboveComponent,
    CheckboxWithTextComponent,
    CheckboxTypeFourComponent,
    CheckboxTypeFiveComponent,
    LabelTypeOneComponent,
    DomainRowsComponent,
    DropdownSelectComponent,
    OtpHeaderFieldComponent,
    ViewCardComponent,
    DataViewWithLoaderComponent,
    CheckboxTypeSixComponent,
    ModalButtonComponent,
    TableComponent,
    ReadyDashboardComponent,
    DomainWithTagsComponent,
    InputSearchFieldsComponent,
    ConsultCardComponent,
    ResendOtpComponent,
    PhoneNumberComponent,
    IntegrationComponent,
    ImageWithTextComponent,
    CustomButtonComponent,
    IntegrationCardsComponent,
    IntegrationCardsProComponent,
    IntegrationListComponent,
    SummaryComponent,
    SummaryCardsComponent,
    SummaryViewComponent,
    ConfigWithButtonComponent,
    ConfigurationCardsComponent,
    CheckboxTypeSevenComponent,
    CheckboxTypeEightComponent,
    LoginCardsComponent,
    GroupedDropdownComponent,
    FilterDropdownComponent,
    FileUploadsComponent,
    CheckboxTextComponent,
    UserInviteComponent,
    FrameworkDetailsComponent,
    DropdownWithSearchComponent,
    RoleDeleteImpactComponent,
  ],
})
export class ComponentsModule {}
